export default (value) => {
    return [
        'bootstrap',
        'tailwind',
    ].indexOf(value) !== -1;
};
